import React, { useState, useEffect, useContext, useRef } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { fetchGetTypes } from "./Api";
import { Contextone } from "./Context";

const SideNav = () => {
  const [types, setTypes] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const countercontext = useContext(Contextone);
  const isurl = countercontext.isDomain;
  const apiUrl = `https://${isurl}`;

  const fetchData = async () => {
    try {
      const data = await fetchGetTypes(apiUrl);
      setTypes(data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [location]);

  const handleNavLinkClick = (path) => {
    if (history.location.pathname === path) {
      fetchData();
    }
    const element = document.querySelector(".side-navbar");
    element.style.display = "none";
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      const element = document.querySelector(".side-navbar");
      element.style.display = "none";
    }
  };

  useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };
  }, []);

  return (
    <>
      <div className="side-navbar" ref={dropdownRef}>
          <ul className="side-menu-ul">
            <li>
              <NavLink
                to={"/"}
                className="side-menu"
                onClick={() => handleNavLinkClick("/")}
                activeClassName="active-link"
              >
                Home
              </NavLink>
            </li>
            {isurl === 'mahuaplay.ottsnap.in' ? 
              types.filter((type)=>type.id !== 5).map((type) => (
                <li key={type.id}>
                  <NavLink
                    to={`/${type.name.replace(/\s+/g, '')}/${type.id}`}
                    activeClassName="active-link"
                    className="side-menu"
                    onClick={() => handleNavLinkClick(`/${type.name.replace(/\s+/g, '')}/${type.id}`)}
                  >
                    {type.name}
                  </NavLink>
                </li>
              )) : 
              <>
              {types.map((type) => (
                <li key={type.id}>
                  <NavLink
                    to={`/${type.name.replace(/\s+/g, '')}/${type.id}`}
                    activeClassName="active-link"
                    className="side-menu"
                    onClick={() => handleNavLinkClick(`/${type.name.replace(/\s+/g, '')}/${type.id}`)}
                  >
                    {type.name}
                  </NavLink>
                </li>
              ))}
              </>
            }
          </ul>

      </div>
    </>
  );
};

export default SideNav;